import { request } from "apis/base";
import { CommonParamsType } from "constants/types/common";
import {
  ProductCategoryRequestBodyType,
  ProductCategoryUpdateBodyType,
} from "constants/types/productCategory";

export const productCategoryApi = {
  getAll: (params?: CommonParamsType) => {
    return request({ url: "/product-category", method: "GET", params });
  },

  create: (data: ProductCategoryRequestBodyType) => {
    return request({ url: "/product-category", method: "POST", data });
  },

  update: (id: string, data: ProductCategoryUpdateBodyType) => {
    return request({ url: `/product-category/${id}`, method: "PUT", data });
  },

  delete: (id: string) => {
    return request({ url: `/product-category/${id}`, method: "DELETE" });
  },
};
